module.exports = __webpack_public_path__ + "img/receivebox4.d60809c6.png";